<template>
  <div >

    <a-modal
        :title='title'
        :visible="visible"
        v-bind="drawerConfig"
        :body-style="{ paddingBottom: '80px' }"
        @cancel="onClose"
    >

    <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout"   layout="vertical">
      <a-form-model-item
          ref="translate_keyword_prompt"
          label="改写产品分类编辑器内容句式："
          prop="rewrite_content_prompt"
          :help="formErr.rewrite_content_prompt"
          :validateStatus='!formErr.rewrite_content_prompt||formErr.rewrite_content_prompt==""?"":"error"'
      >
        <a-input type="textarea" style="height: 180px"
            :maxLength=5000
            v-model="form.rewrite_content_prompt"
            @change="(e) => { formErr.rewrite_content_prompt=''}"
            @blur="(e) => {  form.rewrite_content_prompt = e.target.value.trim();}"
        />
      </a-form-model-item>
    </a-form-model>
    <div class="drawer-btn"  style="text-align: center" >

      <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
        确定
      </a-button>
      <a-button @click="onClose">
        取消
      </a-button>
    </div>
  </a-modal></div>
</template>

<script>
import {submitForm,drawerConfig,validator} from "../../../../../../utils/utils"

import API from "../api";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export default {
  name: "videoForm",
  // props: ["visible","title","editId"],
  props: {
    visible:{type: Boolean,},
    title:{type: String,},
    editId:{type: [String, Number],},

  },
  data() {
    return {
      contenta: "",
      headers: {Authorization: window.sessionStorage.getItem("signature")},
      seleList:[],
      fileList:[],
      previewVisible: false,
      previewImage: "",
      drawerConfig ,
      form: {
        rewrite_content_prompt:"",
        type:"1",
      },
      formErr: {
        rewrite_content_prompt:"",
      },
      rules: {
        rewrite_content_prompt: [{required: true, message: "请输入改写产品编辑器内容句式",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.rewrite_content_prompt)}  , trigger: "blur"  },],
      },
      layout: {
        // labelCol: { span:3},
        // wrapperCol: { span: 20 },

      },
    };

  },
  watch:{
    editId: function (a, b) {
      if (a != "") {
        API.service.EDIT_DATAS(a).then(res => {
          let data=res.data.data.info
          this.form = data
          this.form.id=a
          this.form.type='2'
        })
      } else {
        this.form.id = ''
        this.form.type='2'
      }
    }
  },
  mounted(){
  },
  methods: {

    handleCancel() {
      this.previewVisible = false;
    },

    onClose() {
      this.$emit("changVisible", false);
      this.fileList=[]
      this.formErr={
        rewrite_content_prompt:"",
      }
      this.$refs.ruleForm.resetFields();
    },
    onSubmit() {
      let _this = this;

      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url
          let subData=JSON.parse(JSON.stringify(this.form))

          subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADDS : url = API.service.SUBMIT_EDITS
          if(subData.id == '' || subData.id == undefined){
            submitForm(url, {rewrite_content_prompt: subData.rewrite_content_prompt, type: 2}).then(res => {
              if (res == true) {
                this.onClose()
              } else {
                res.map((item, index) => {
                  this.formErr[item.field] = item.msg
                })
              }
            })
          }else {
            submitForm(url, subData).then(res => {
              if (res == true) {
                this.onClose()
              } else {
                res.map((item, index) => {
                  this.formErr[item.field] = item.msg
                })
              }
            })
          }
        } else {
          return false;
        }
      });
    },
  },
}
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
.box >>> .ant-form-extra{top:calc(100% - 30px) !important;position: absolute}
.box >>> .ant-form-item-control-wrapper{position: relative}
.drawer-btnt{text-align:center;}
</style>
